// extracted by mini-css-extract-plugin
export default {"error-message":"app-qualityControl-packetAssignment-staff-StaffItemAssignButton-module__FeZr1vEex8bXK615qZeo"};